import Vue from 'vue'
import Counter from '@/helpers/Counter'

import plusMinus_row_cell from './plus-minus-row-cell'
Vue.component(plusMinus_row_cell.name, plusMinus_row_cell)

let counter = new Counter('AdvancedTable')

const UNIQUE_ID_PARAM = '$_unique_id'
const NEW_ROW_PARAM = '$_is_new'

export default {
    slots() {
        return [
            {
                slot: "row-cell",
                component: plusMinus_row_cell.name,
                condition(attrs) {
                    return attrs.col.type === 'PlusMinusColumn'
                }
            }
        ]
    },
    mixins() {
        return {
            inject: {
                form: {
                    default: false
                }
            },
            props: {
                markNewRows: { // makes the background green
                    type: Boolean,
                    default: true
                },
                addRowCondition: {
                    type: [Function, Boolean],
                    default: true
                },
                removeRowCondition: {
                    type: [Function, Boolean],
                    default: true
                }
            },
            watch: {
                data: {
                    immediate: true,
                    handler() {
                        if ( ! isArray(this.$_data) ) {
                            this.$emit('input', [])
                        }
                        else if ( this.$_data.length === 0 ) {
                            this.addRow(0, true)
                        }

                        this.generateUniqueIndex()

                        if( this.lastAddedRowIndex !== undefined )
                        {
                            this.getColumns().forEach( col => {
                                if(col.dataType === undefined && col.field === undefined) {
                                    return
                                }

                                this.form.validator().applyDefaultValue(this.prefix + '.' + this.lastAddedRowIndex + '.' + col.field)
                            })

                            this.lastAddedRowIndex = undefined
                        }
                    }
                }
            },
            created() {
                if( this.form )
                {
                    this.form.validator().setUniqueKeyParam(UNIQUE_ID_PARAM)
                    this.form.validator().applyDefaultValues()
                }

                // make new rows to be green
                this.internalRowOptions.push(
                    (row, index) => {
                        if( this.markNewRows && row[NEW_ROW_PARAM] ) {
                            return {
                                style: {
                                    background: '#e6f3e4'
                                }
                            }
                        }

                        return {}
                    }
                )
            },
            methods: {
                // public
                addRow(index, force = false) {
                    this.form.validator().clearUniqueFieldKeyCache()

                    let addRowCondition = typeOf(this.addRowCondition) === 'function'
                        ? this.addRowCondition(index)
                        : this.addRowCondition

                    if( force === false && ! addRowCondition ) {
                        this.$emit('restrict-add', index)
                        return
                    }

                    let newRecord = this.pmc_createNewRecord()

                    this.$emit('before-add', newRecord)

                    let data = this.$_data.slice()

                    if ( ! data.length ) {
                        data.push(newRecord)
                        this.lastAddedRowIndex = 0
                    } else {
                        data.splice(index + 1, 0, newRecord)
                        this.lastAddedRowIndex = index + 1
                    }

                    this.$emit('input', data)
                    this.$emit('after-add', index + 1, newRecord)
                },
                removeRow(index) {
                    this.form.validator().clearUniqueFieldKeyCache()

                    let removeRowCondition = typeOf(this.removeRowCondition) === 'function'
                        ? this.removeRowCondition(index)
                        : this.removeRowCondition

                    if( ! removeRowCondition ) {
                        this.$emit('restrict-remove', index)
                        return
                    }

                    this.pmc_clearFormState(index)

                    let data = this.$_data.slice()

                    let row = data[index]
                    this.$emit('before-remove', index, row)

                    data.splice(index, 1)

                    this.$emit('input', data)
                    this.$emit('after-remove', index, row)
                },
                // internal
                generateUniqueIndex() {
                    for( let row of this.$_data ) {
                        if ( row.hasOwnProperty(UNIQUE_ID_PARAM) ) {
                            continue
                        }

                        Object.defineProperty(row, UNIQUE_ID_PARAM, {
                            value: 'uid-' + counter.increment(),
                            enumerable: false,
                            writable: false
                        })
                    }
                },
                getRowUniqueIndex(row, index) {
                    return row[UNIQUE_ID_PARAM]
                },
                pmc_clearFormState(index) {
                    // clear all errors starting with the row index:
                    if( this.form && this.prefix !== undefined ) {
                        let key = `${this.prefix}.${index}`

                        if( ! this.form.hasDeep(key) ) {
                            console.warn(`[Table::PlusMinusColumn] Invalid value for property prefix: "${this.prefix}". `)
                        }

                        let row = this.form.getDeep(key)
                        let realKey = `${this.prefix}.${this.getRowUniqueIndex(row)}`

                        let matches = this.form.getValidator().getDirtyFields().filter(
                            key => key.indexOf(realKey) === 0
                        )

                        for(let field of matches) {
                            this.form.resetField(field)
                        }
                    }
                },
                pmc_createNewRecord() {
                    let recordTemplate = {}

                    this.getColumns().forEach( col => {
                        if(col.dataType === undefined && col.field === undefined) {
                            return
                        }
                        let type = col.dataType ? JSON.parse(JSON.stringify(col.dataType)) : ""
                        recordTemplate[col.field] = type
                    })

                    Object.defineProperty(recordTemplate, UNIQUE_ID_PARAM, {
                        value: 'uid-' + counter.increment(),
                        enumerable: false,
                        writable: false
                    })

                    Object.defineProperty(recordTemplate, NEW_ROW_PARAM, {
                        value: true,
                        enumerable: false
                    })

                    return recordTemplate
                }
            }
        }
    }
}
